import { useState, useEffect, useMemo } from "react";
import "./Sidebarr.css"; // Assuming this file contains your sidebar styles
import Header from "../Components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLayerGroup,
  faChevronDown,
  faBookOpen,
  faCalendarDays,
  faSearch,
  faExclamationTriangle,
  faChevronUp,
  faPlusCircle,
  faFilter,
  faFileAlt,
  faClock,
  faUserGraduate,
  faStar,
  faPlayCircle,
} from "@fortawesome/free-solid-svg-icons";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import StudentSdebar from "./StudentSdebar";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { MDBProgress, MDBProgressBar } from "mdb-react-ui-kit";
import Alert from "react-bootstrap/Alert";
import { motion, AnimatePresence } from "framer-motion";
import bannerImage from '../Images/Banner_new.jpg'; // A placeholder image

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [displayedCards, setDisplayedCards] = useState(6); // Show more by default
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("default");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isExpanded, setIsExpanded] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const navigate = useNavigate();

  const redirect = (id) => {
    navigate(`/Course/${id}`);
  };

  const redirectToCoursePage = () => {
    navigate("/CoursePage");
  };

  const handleViewSyllabus = (course, event) => {
  event.stopPropagation(); // Prevent card click

  const keyPoints = Array.isArray(course.course_key_points)
    ? course.course_key_points
    : [];

  Swal.fire({
    title: `Syllabus - ${course.title}`,
    html: `
      <div style="text-align: left;">
        <h5 style="color: #B8529E; margin-bottom: 15px;">Course Key Points</h5>

        ${
          keyPoints.length > 0
            ? `
              <ul style="padding-left: 20px;">
                ${keyPoints
                  .map(
                    (point) =>
                      `<li style="margin-bottom: 8px;">${point}</li>`
                  )
                  .join("")}
              </ul>
            `
            : `<p style="color:#777;">No syllabus available.</p>`
        }

       
      </div>
    `,
    icon: "info",
    confirmButtonText: "Got It",
    confirmButtonColor: "#B8529E",
    width: "500px",
  });
};


  const handleResumeCourse = (courseId, courseTitle, event) => {
    event.stopPropagation();
    Swal.fire({
      title: 'Continue Learning?',
      text: `Resume "${courseTitle}" from where you left off.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Resume',
      cancelButtonText: 'Later',
      confirmButtonColor: '#B8529E',
      cancelButtonColor: '#6c757d'
    }).then((result) => {
      if (result.isConfirmed) {
        redirect(courseId);
      }
    });
  };

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("jwttoken");
      try {
        const response = await axios.get("https://kaasbackend.vetrinahealthcare.com/lms/user/courses/", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setCourses(response.data.courses || []);
      } catch (error) {
        console.error("Error fetching courses:", error);
        setError(error.response?.data?.detail || error.message || "Failed to fetch courses.");
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  const categories = useMemo(() => {
    const allCategories = new Set();
    courses.forEach(course => {
      course.categories.forEach(cat => allCategories.add(cat));
    });
    return ["All", ...Array.from(allCategories)];
  }, [courses]);

  const filteredCourses = useMemo(() => {
    return courses
      .filter(course => {
        const matchesCategory = selectedCategory === "All" || course.categories.includes(selectedCategory);
        const matchesSearch =
          course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (course.description && course.description.toLowerCase().includes(searchTerm.toLowerCase()));
        return matchesCategory && matchesSearch;
      })
      .sort((a, b) => {
        switch (sortBy) {
          case "title":
            return a.title.localeCompare(b.title);
          case "progress":
            return (b.course_progress || 0) - (a.course_progress || 0);
          case "date":
            return new Date(b.start_date) - new Date(a.start_date);
          default:
            return 0;
        }
      });
  }, [courses, searchTerm, selectedCategory, sortBy]);

  const handleViewAll = () => {
    setIsExpanded(true);
    setDisplayedCards(courses.length);
  };

  const handleViewLess = () => {
    setIsExpanded(false);
    setDisplayedCards(6);
  };
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.08 } },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 100 } },
  };

  const CourseCardSkeleton = () => (
    <motion.div className="col-lg-4 col-md-6 col-12 mb-4" variants={itemVariants}>
      <Card className="h-100 course-card-skeleton">
        <div style={{
          height: "160px",
          overflow: "hidden",
          backgroundColor: "#f8f9fa",
          position: "relative"
        }}>
          <div style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#e0e0e0"
          }} />
        </div>
        <Card.Body className="d-flex flex-column p-3">
          <div className="skeleton-line short mb-2"></div>
          <div className="skeleton-title mb-3"></div>
          <div className="skeleton-line mb-1"></div>
          <div className="skeleton-line mb-4"></div>
          <div className="mt-auto">
            <div className="skeleton-progress-bar mb-2"></div>
            <div className="skeleton-button"></div>
          </div>
        </Card.Body>
      </Card>
    </motion.div>
  );

  return (
    <div className="courses-page-container">
      <Header />
      <div className="wrapper">
        <StudentSdebar onToggle={setSidebarExpanded} />
        <motion.div 
          className="main-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            marginLeft: sidebarExpanded ? '240px' : '60px',
            transition: 'margin-left 0.25s ease-in-out',
            width: `calc(100% - ${sidebarExpanded ? '240px' : '60px'})`
          }}
        >
          {/* Centered Header Section */}
          <motion.div
            className="page-header-container text-center mb-5"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 120, delay: 0.2 }}
          >
            <h1 className="page-title mb-3">My Learning Journey</h1>
            <p className="page-subtitle">
              Continue your educational adventure. Track progress, access materials, and achieve your learning goals.
            </p>
            <div className="stats-container d-flex justify-content-center flex-wrap gap-4 mt-4">
              <div className="stat-item">
                <div className="stat-number">{courses.length}</div>
                <div className="stat-label">Total Courses</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {Math.round(courses.reduce((acc, course) => acc + (course.course_progress || 0), 0) / (courses.length || 1))}%
                </div>
                <div className="stat-label">Average Progress</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {courses.filter(course => (course.course_progress || 0) >= 100).length}
                </div>
                <div className="stat-label">Completed</div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="controls-container row mb-4 gx-3 gy-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="col-lg-5 col-md-12">
              <div className="input-group custom-input-group">
                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search my courses..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="input-group custom-input-group">
                <span className="input-group-text"><FontAwesomeIcon icon={faFilter} /></span>
                <select 
                  className="form-select" 
                  value={selectedCategory} 
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="input-group custom-input-group">
                <span className="input-group-text">Sort By</span>
                <select 
                  className="form-select" 
                  value={sortBy} 
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="default">Default</option>
                  <option value="title">Title (A-Z)</option>
                  <option value="progress">Progress</option>
                  <option value="date">Start Date</option>
                </select>
              </div>
            </div>
          </motion.div>

          <AnimatePresence>
            {loading ? (
              <motion.div className="row" variants={containerVariants} initial="hidden" animate="visible">
                {[...Array(6)].map((_, index) => <CourseCardSkeleton key={`skeleton-${index}`} />)}
              </motion.div>
            ) : error ? (
              <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                <Alert variant="danger" className="text-center error-alert">
                  <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 fa-2x" />
                  <h4>Loading Failed</h4>
                  <p>{typeof error === 'string' ? error : "Could not load courses. Please try again later."}</p>
                </Alert>
              </motion.div>
            ) : filteredCourses.length > 0 ? (
              <>
                <motion.div className="row" variants={containerVariants} initial="hidden" animate="visible">
                  {filteredCourses.slice(0, displayedCards).map(course => (
                    <motion.div
                      key={course.course_id}
                      className="col-lg-4 col-md-6 col-12 mb-4"
                      variants={itemVariants}
                      layout
                    >
                      <Card className="h-100 course-card" onClick={() => redirect(course.course_id)}>
                        {/* Image container with inline styles */}
                        <div style={{
                          height: "160px",
                          overflow: "hidden",
                          backgroundColor: "#f8f9fa",
                          position: "relative"
                        }}>
                          <img
                            src={course.cover_img || bannerImage}
                            alt={course.title}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              transition: "transform 0.3s ease"
                            }}
                            onError={(e) => {
                              e.target.src = bannerImage;
                            }}
                          />
                          {/* Course Badges */}
                          <div style={{
                            position: "absolute",
                            top: "12px",
                            left: "12px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px"
                          }}>
                            {course.categories && course.categories[0] && (
                              <span style={{
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                backdropFilter: "blur(5px)"
                              }}>
                                {course.categories[0]}
                              </span>
                            )}
                            {(course.course_progress || 0) >= 100 && (
                              <span style={{
                                backgroundColor: "rgba(76, 175, 80, 0.5)",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                backdropFilter: "blur(5px)"
                              }}>
                                <FontAwesomeIcon icon={faStar} className="me-1" />
                                Completed
                              </span>
                            )}
                          </div>
                          
                          {/* Progress Overlay */}
                          <div style={{
                            position: "absolute",
                            bottom: "0",
                            left: "0",
                            right: "0",
                            background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                            padding: "10px",
                            color: "white",
                            fontSize: "0.8rem"
                          }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>Progress</span>
                              <span className="fw-bold">{Math.round(course.course_progress || 0)}%</span>
                            </div>
                          </div>
                        </div>
                        
                        <Card.Body className="d-flex flex-column p-3">
                          <Card.Title className="course-title mb-2">
                            {course.title}
                          </Card.Title>
                          
                          {/* Course Meta Information */}
                          <div className="course-meta d-flex justify-content-between align-items-center mb-2">
                            <div className="instructor-info">
                              <FontAwesomeIcon icon={faUserGraduate} className="me-1 text-primary" />
                              <small className="text-muted">Vetrina Healthcare</small>
                            </div>
                            <div className="duration-info">
                              <FontAwesomeIcon icon={faClock} className="me-1 text-warning" />
                              <small className="text-muted">{course.duration || 'Self-paced'}</small>
                            </div>
                          </div>

                          {/* Course Description */}
                          <p className="course-description small text-muted mb-3">
                            {course.description || 'Explore this comprehensive course designed to enhance your skills and knowledge.'}
                          </p>
                          
                          <div className="progress-section mt-auto">
                            <div className="progress-details d-flex justify-content-between mb-1">
                                <span className="lessons-count">
                                    <FontAwesomeIcon icon={faLayerGroup} /> {course.completed_parts} / {course.total_parts} Parts
                                </span>
                                <span className="progress-value fw-bold" style={{
                                  color: (course.course_progress || 0) >= 100 ? '#4CAF50' : '#B8529E'
                                }}>
                                    {Math.round(course.course_progress || 0)}%
                                </span>
                            </div>
                            <MDBProgress height="8" className="course-progress-bar">
                              <MDBProgressBar
                                width={Math.round(course.course_progress || 0)}
                                valuemin={0}
                                valuemax={100}
                                className="progress-bar-custom"
                              />
                            </MDBProgress>
                            
                            {/* Action Buttons */}
                            <div className="d-flex justify-content-between align-items-center mt-3 gap-2">
                              <Button 
                                variant="outline-custom" 
                                className="btn-view-syllabus flex-fill"
                                onClick={(e) => handleViewSyllabus(course, e)}
                                size="sm"
                              >
                                <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                Syllabus
                              </Button>
                              
                              <Button 
                                variant="primary" 
                                className="btn-resume flex-fill"
                                onClick={(e) => handleResumeCourse(course.course_id, course.title, e)}
                                size="sm"
                                disabled={(course.course_progress || 0) >= 100}
                              >
                                <FontAwesomeIcon icon={(course.course_progress || 0) >= 100 ? faStar : faPlayCircle} className="me-2" />
                                {(course.course_progress || 0) >= 100 ? 'Completed' : 'Resume'}
                              </Button>
                            </div>

                            {/* Last Accessed */}
                            <div className="text-center mt-2">
                              <small className="text-muted">
                                Last accessed: {course.last_accessed ? new Date(course.last_accessed).toLocaleDateString() : 'Never'}
                              </small>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  ))}
                </motion.div>

                {filteredCourses.length > 6 && (
                  <motion.div className="view-toggle-container text-center mt-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                    {isExpanded ? (
                       <Button variant="custom" className="btn-view-toggle" onClick={handleViewLess}>
                        <FontAwesomeIcon icon={faChevronUp} className="me-2" /> Show Less
                      </Button>
                    ) : (
                      <Button variant="custom" className="btn-view-toggle" onClick={handleViewAll}>
                        <FontAwesomeIcon icon={faChevronDown} className="me-2" /> Show All ({filteredCourses.length} courses)
                      </Button>
                    )}
                  </motion.div>
                )}
              </>
            ) : (
              <motion.div className="no-courses-found" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
                <FontAwesomeIcon icon={faBookOpen} className="no-courses-icon" />
                <h3 className="mb-3">No Courses Found</h3>
                <p className="text-muted mb-4">
                  {searchTerm || selectedCategory !== "All" ? "No courses match your filters. Try a different search or category." : "You are not enrolled in any courses yet."}
                </p>
                <Button variant="custom" className="btn-explore-courses" onClick={redirectToCoursePage}>
                  <FontAwesomeIcon icon={faPlusCircle} className="me-2" /> Explore Available Courses
                </Button>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>

      <style jsx global>{`
        /* GENERAL PAGE STYLES */
        .courses-page-container {
          background-color: #f8f9fa;
          min-height: 100vh;
        }
        
        .wrapper {
          display: flex;
          padding-top: 60px;
        }

        .main-content {
          flex-grow: 1;
          padding: 1.5rem 2rem;
        }

        /* CENTERED HEADER STYLES */
       .page-header-container {
  background: linear-gradient(135deg, #b60dccff 0%, #451258ff 100%);
  color: white;
  padding: 1.5rem 2rem; /* Reduced top/bottom padding from 3rem → 1.5rem */
  border-radius: 20px;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}


        .page-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .page-subtitle {
          font-size: 1.1rem;
          opacity: 0.9;
          max-width: 600px;
          margin: 0 auto;
        }

        .stats-container {
          margin-top: 2rem;
        }

        .stat-item {
          text-align: center;
          padding: 0 1.5rem;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          font-size: 0.9rem;
          opacity: 0.8;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* CONTROLS (SEARCH & SORT) */
        .controls-container {
          background-color: #ffffff;
          padding: 1rem;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
          border: 1px solid #e9ecef;
        }
        .custom-input-group .input-group-text {
          background-color: transparent;
          border-right: none;
          color: #B8529E;
          font-size: 0.9rem;
        }
        .custom-input-group .form-control,
        .custom-input-group .form-select {
          border-left: none;
          box-shadow: none;
          font-size: 0.95rem;
        }
        .custom-input-group .form-control:focus,
        .custom-input-group .form-select:focus {
          border-color: #f4811ee5;
          box-shadow: none;
        }

        /* --- COURSE CARD STYLES --- */
        .course-card {
          background-color: #ffffff;
          border-radius: 15px;
          border: 1px solid #e9ecef;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          overflow: hidden;
          cursor: pointer;
        }
        .course-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
        }

        .course-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #2c3e50;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;  
          overflow: hidden;
          min-height: 44px;
        }

        .course-description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 1.4;
        }

        .course-meta {
          font-size: 0.8rem;
        }

        /* PROGRESS BAR */
        .progress-section {}
        .progress-details {
          font-size: 0.8rem;
          color: #555;
        }
        .lessons-count svg {
          margin-right: 5px;
          color: #B8529E;
        }
        .course-progress-bar {
          border-radius: 20px;
          background-color: #e9ecef;
        }
        .progress-bar-custom {
          background: linear-gradient(90deg, #f4811ee5, #B8529E) !important;
          border-radius: 20px;
        }
        
        /* BUTTONS */
        .btn-view-toggle, .btn-explore-courses {
          border-radius: 25px;
          font-weight: 600;
          font-size: 0.9rem;
          border: 1px solid #e0e0e0;
          background-color: #fff;
          color: #333;
          transition: all 0.3s ease;
        }
        .btn-view-toggle:hover {
          background-color: #f8f9fa;
          transform: translateY(-2px);
          border-color: #ccc;
        }
        .btn-explore-courses {
          background: linear-gradient(90deg, #f4811ee5, #B8529E);
          color: white;
          border: none;
        }
        .btn-explore-courses:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        /* VIEW SYLLABUS BUTTON */
        .btn-view-syllabus {
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
          border: 1px solid #B8529E;
          color: #B8529E;
          background-color: transparent;
          padding: 0.375rem 0.75rem;
          transition: all 0.3s ease;
        }
        .btn-view-syllabus:hover {
          background-color: #B8529E;
          color: white;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(184, 82, 158, 0.3);
        }

        /* RESUME BUTTON */
        .btn-resume {
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
          background: linear-gradient(45deg, #f4811ee5, #ff6b6b);
          border: none;
          padding: 0.375rem 0.75rem;
          transition: all 0.3s ease;
        }
        .btn-resume:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(244, 129, 30, 0.3);
        }
        .btn-resume:disabled {
          background: #4CAF50;
          opacity: 0.8;
        }

        /* NO COURSES & ERROR */
        .no-courses-found, .error-alert {
          text-align: center;
          padding: 3rem 1rem;
          background-color: #ffffff;
          border-radius: 20px;
          border: 1px solid #e9ecef;
          margin-top: 2rem;
        }
        .no-courses-icon {
          font-size: 4rem;
          color: #B8529E;
          margin-bottom: 1.5rem;
        }

        /* SKELETON LOADER */
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
        .course-card-skeleton { position: relative; overflow: hidden; background-color: #fff; }
        .course-card-skeleton::after {
          position: absolute; top: 0; right: 0; bottom: 0; left: 0;
          transform: translateX(-100%);
          background-image: linear-gradient(90deg, rgba(255,255,255,0) 0, rgba(255,255,255,0.2) 20%, rgba(255,255,255,0.5) 60%, rgba(255,255,255,0));
          animation: shimmer 2s infinite;
          content: '';
        }
        .skeleton-title { height: 20px; width: 80%; background-color: #e0e0e0; border-radius: 4px; }
        .skeleton-line { height: 16px; width: 100%; background-color: #e0e0e0; border-radius: 4px; }
        .skeleton-line.short { width: 40%; }
        .skeleton-progress-bar { height: 8px; width: 100%; background-color: #e0e0e0; border-radius: 4px; }
        .skeleton-button { display: none; }

        /* RESPONSIVE DESIGN */
        @media (max-width: 768px) {
          .page-title {
            font-size: 2rem;
          }
          
          .page-subtitle {
            font-size: 1rem;
          }
          
          .stats-container {
            flex-direction: column;
            gap: 1rem;
          }
          
          .stat-item {
            padding: 0 1rem;
          }
          
          .main-content {
            padding: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Courses;